import kocLogo from "../../assets/images/koc-logo.png";
import { HomePageContainer, WelcomeCard, WelcomeLogo, WelcomeSubtitle, WelcomeTitle } from "./style";

const HomePage = () => {
	return (
		<HomePageContainer>
			<WelcomeCard>
				<WelcomeLogo src={kocLogo} alt="Koç Logo" />
				<WelcomeTitle>İçinde Koç Var Admin Paneline<br />Hoş Geldiniz</WelcomeTitle>
				<WelcomeSubtitle>Başlamak için solda bulunan menüden bir bölüm seçebilirsiniz.</WelcomeSubtitle>
			</WelcomeCard>
		</HomePageContainer>
	);
};

export default HomePage;

